/** Backend SearchConfig.recordType values */
export const SEARCH_RECORD_TYPE = {
  PROJECT: 'PROJECT',
  COLLECTION: 'COLLECTION',
};

/** Backend SearchConfig.ProjectVisibility values */
export const SEARCH_VISIBILITY = {
  MY_PROJECTS: 'MY_PROJECTS',
  PUBLIC_PROJECTS: 'PUBLIC_PROJECTS',
};

/** Backend SearchConfig.DatePreset values */
export const DATE_PRESET = {
  TODAY: 'TODAY',
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
};

export const DATE_PRESET_LABELS = {
  [DATE_PRESET.TODAY]: 'Today',
  [DATE_PRESET.THIS_WEEK]: 'This week',
  [DATE_PRESET.THIS_MONTH]: 'This month',
};

export const SUPPORTED_ROLE_VALUES = ['OWNER', 'CONTRIBUTOR', 'VIEWER'];

export const PRESET_SAVE_NOTICE =
  'Only tab, statuses, roles, and Today / This week / This month are saved. Keyword search, custom date ranges, ratings, tags, and "include my public" are not included.';
